import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=274790a2&"
import script from "./activityRecord.vue?vue&type=script&lang=js&"
export * from "./activityRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports